var _rect, _path, _ellipse;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFmhAttentionIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 8,
    fill: "#D4351C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0095 3C8.3722 3.00033 8.66584 3.2058 8.66537 3.45893L8.6602 6.20833L8.6602 6.66667L8.64548 7.125L8.65848 7.125L8.65331 9.8756C8.65284 10.1287 8.35843 10.3337 7.99573 10.3333C7.63303 10.333 7.33939 10.1275 7.33987 9.8744L7.34503 7.125C7.3321 7.125 7.33203 6.66667 7.33203 6.66667C7.33203 6.66667 7.33203 6.20833 7.34508 6.20833L7.34675 6.20833L7.35192 3.45773C7.35239 3.2046 7.6468 2.99967 8.0095 3Z",
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 8.0013,
    cy: 12.3333,
    rx: 0.666667,
    ry: 0.666666,
    transform: "rotate(-180 8.0013 12.3333)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFmhAttentionIcon);
export default __webpack_public_path__ + "static/media/fmh-attention-icon.56b2705d6645109ff2ae3474d67d1729.svg";
export { ForwardRef as ReactComponent };